export default defineNuxtPlugin(() => {
  onNuxtReady(() => {
    // skip convertcom for desktop
    if (window.isDesktop) return;
    var script = document.createElement('script');
    script.src = '//cdn-4.convertexperiments.com/js/10046307-10046776.js';
    script.async = false;
    document.head.appendChild(script);
  });
});